export default "__VITE_ASSET__Cm$n7y5G__"